import { tokens } from "./v4-tokens";
import { createThemes } from "@tamagui/theme-builder";
import { themes } from "./generated-v4-tamagui";
import { themes as themes2 } from "./generated-v4";
export {
  createThemes,
  themes2 as defaultThemes,
  themes as tamaguiThemes,
  tokens
};
//# sourceMappingURL=v4.js.map
